import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// The local Tribu preview does not load App, Supabase, or production providers.
const App = React.lazy(() => window.location.pathname.startsWith('/tribe-preview')
  ? import('./features/tribePreview/TribePreviewApp')
  : import('@/App'));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <React.Suspense fallback={<div role="status" data-testid="app-loading" style={{ padding: 24 }}>MOHAI</div>}><App /></React.Suspense>
  </React.StrictMode>,
);
